<template>
  <div class="flow-ad" @click="toAdPage">
    <div class="a-info">
      <img
        :src="
          adInfo.cover ? addOssParamsForcibly(adInfo.cover, 80) : defaultAvatar
        "
        alt=""
      />
      <p v-html="adInfo.title2"></p>
    </div>
    <p class="a-content" v-html="adInfo.title"></p>
    <div class="a-img">
      <img :src="addOssParamsForcibly(adInfo.image, 318)" alt="" />
    </div>
  </div>
</template>

<script>
import { GetQueryString } from 'lib/tools/utils'
import { addOssParamsForcibly } from 'utils/tool.js'

export default {
  props: {
    adInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      defaultAvatar: require('images/consult/share.jpg')
    }
  },
  methods: {
    addOssParamsForcibly,
    toAdPage() {
      let obj = this.adInfo

      this.$trackEvent('qa_question_details_ad', {
        item_id: obj.id,
        item_name: obj.title2
      })

      //todo:需要运营手动配置hidenav参数隐藏头部
      const hideNavigationBar = GetQueryString('hidenav', obj.url)
      const { isYixinliApp, isZiXunApp } = this.$platform
      // 不能使用routePush，一些广告位测试需要跳转到线上
      if (isYixinliApp || isZiXunApp) {
        let isOpenWebview = true
        if (
          obj.url.indexOf('yixinli://') === 0 ||
          obj.url.indexOf('muse://') === 0
        ) {
          isOpenWebview = false
        }
        // 如果是http协议用openWebView打开页面，如果是原生协议则用window.location.href
        if (isOpenWebview) {
          this.$bridge.openWebView({
            url: obj.url,
            isCurrentPageOpen: 0,
            hideNavigationBar: hideNavigationBar ? 1 : 0
          })
        } else {
          window.location.href = obj.url
        }
      } else {
        if (obj.path) {
          this.$router.push(obj.path)
        } else {
          window.location.href = obj.url
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.flow-ad {
  padding: 32px;
  box-sizing: border-box;
  .a-info {
    display: flex;
    align-items: center;
    img {
      width: 80px;
      height: 80px;
      object-fit: cover;
      border-radius: 50%;
      margin-right: 20px;
    }
    p {
      font-size: 28px;
      font-weight: 600;
      color: #21252d;
    }
  }
  .a-content {
    font-size: 30px;
    font-weight: 400;
    color: #6c798c;
    line-height: 1.5;
    margin: 20px 0;
    white-space: pre-wrap;
  }
  .a-img {
    img {
      width: 317px;
      height: 186px;
      object-fit: cover;
      border-radius: 10px;
    }
  }
}
</style>
